module.exports = __webpack_public_path__ + "img/845-32858d.png";